import { render, staticRenderFns } from "./DashboardElementCreateForm.vue?vue&type=template&id=2f37dd81&scoped=true&"
import script from "./DashboardElementCreateForm.vue?vue&type=script&lang=js&"
export * from "./DashboardElementCreateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f37dd81",
  null
  
)

export default component.exports